<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="false"
    :isAdd="false"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    this.itemLink = `business/lessonplans/${this.id}/works`;
    this.setLink = `business/lessonplans/${this.id}/works`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_work_view",
      itemLink: "address",
      setLink: "address",
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          disableLink: true,
          object: "title",
        },

        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
